import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function Live() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [imageFile, setImageFile] = useState(null);

  const [live, setLive] = useState({
    hostname: "",
    image: "",
    link: "",
    youtube: "",
    instagram: "",
    status: "", 
  });

  const onChangeLive = (e) => {
    const { name, value } = e.target;

    setLive((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const fetchLive = async () => {

    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/live/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setLive(json.data || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };

  useEffect(() => {
    fetchLive();
  }, []);

  const updateLive = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // append text fields
      formData.append("hostname", live.hostname);
      formData.append("link", live.link);
      formData.append("instagram", live.instagram);
      formData.append("youtube", live.youtube);
      formData.append("status", live.status);

      // append video jika ada
      if (imageFile) {
        formData.append("image", imageFile);
      }

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/live/1`,
        {
          method: "POST",
          body: formData, // 
        }
      );

      if (!res.ok) throw new Error("Gagal update");

      const result = await res.json();

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Link LIVE berhasil diperbarui!",
        showConfirmButton: false,
        timer: 3000,
      });

    } catch (err) {
      Swal.fire("Error", "Gagal update data", "error");
    } finally {
      setLoading(false);
    }
  };

  const onChangeLiveImage = (e) => {
    const file = e.target.files[0];

    if (file) {    
      setImageFile(file);
    }
  };  

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-slate-950"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                Link LIVE
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Hostname</label>
                  <input
                    type="text"
                    name="hostname"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={live?.hostname}
                    onChange={onChangeLive}
                    required
                  />
                </div>
                
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Status</label>
                  <select
                    name="status"
                    onChange={onChangeLive}
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="">-- ubah status --</option>
                    <option value="1">
                      Aktif
                    </option>
                    <option value="0">
                      Tidak Aktif
                    </option>
                  </select>
                </div>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Image</label>
                  <input
                    type="file"
                    name='image'
                    accept="image/*"
                    onChange={onChangeLiveImage}
                    className="block w-full text-sm file:mr-4 file:py-2 file:px-4
                    file:rounded-md file:border-0
                    file:bg-blue-600 file:text-white
                    hover:file:bg-blue-700 mb-4"
                  />  
                </div>
              </div>
              <div className="flex flex-row">
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Tiktok</label>
                  <input
                    type="text"
                    name="link"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={live?.link}
                    onChange={onChangeLive}
                    required
                  />
                </div>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Instagram</label>
                  <input
                    type="text"
                    name="instagram"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={live?.instagram}
                    onChange={onChangeLive}
                    required
                  />
                </div>
                <div className='w-1/3 p-4'>
                  <label className="block mb-1 font-medium ">Youtube</label>
                  <input
                    type="text"
                    name="youtube"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={live?.youtube}
                    onChange={onChangeLive}
                    required
                  />
                </div>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={updateLive} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Simpan</button>
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </section>
      
    </div>
  );
}

export default Live;
